import { render, staticRenderFns } from "./editTopic.vue?vue&type=template&id=52bbceea&scoped=true"
import script from "./editTopic.vue?vue&type=script&lang=js"
export * from "./editTopic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52bbceea",
  null
  
)

export default component.exports